import { render } from "@/components/webPhone/template/phone.html?vue&type=template&id=9648b36c&scoped=true"
import script from "./phone.vue?vue&type=script&lang=js"
export * from "./phone.vue?vue&type=script&lang=js"

import "./phone.vue?vue&type=style&index=0&id=9648b36c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\david\\Documents\\Dada\\Omnichannel-Dada\\dashboard-agente\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9648b36c"]])

export default __exports__